import { Button } from "@features/ui/Button"
import { observer } from "mobx-react-lite"
import { authStore } from "../../auth/tess-session.store"
import { useState } from "react"
import { flyingCarpetStore } from "../flying-carpet.store"

type Props = {
  onSuccess?: () => void
}

export const SignInPanel = observer((props: Props) => {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState<string | null>(null)
  const isLoading = authStore.isSessionLoading

  return (
    <form
      className="flex flex-col gap-3 px-shelf py-5"
      onSubmit={(e) => {
        e.preventDefault()
        setError(null)
        authStore.signIn(email, password).then((result) => {
          if (result.success) {
            if (props.onSuccess) {
              props.onSuccess()
            } else {
              flyingCarpetStore.open("account")
            }
          } else {
            setError(result.error)
          }
        })
      }}
    >
      {/* <h2 className="type-title-l">Sign In</h2> */}
      {error && <div className="text-[red]">{error}</div>}
      <div>
        <div className="type-ui-l mb-2">Your email address</div>
        <input
          type="email"
          placeholder="Email"
          className="w-full border p-1"
          disabled={isLoading}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>
      <div>
        <div className="type-ui-l mb-2">Enter your password</div>
        <input
          type="password"
          placeholder="Password"
          className="w-full border p-1"
          disabled={isLoading}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>
      <Button type="submit" className="mt-2" disabled={isLoading}>
        {isLoading ? "Signing In" : "Sign In"}
      </Button>
      <div className="flex flex-col gap-2 underline underline-offset-2">
        <a href="#">I've forgotten my password</a>
        <a href="#">Create an account</a>
      </div>
    </form>
  )
})
